import { createContext, useContext, useMemo, useState } from "react";

export const ModalContext = createContext<ModalContextProviderProps>({
    closeModal: () => {}
});

export const useModal = (): ModalContextProviderProps => {
    return useContext(ModalContext);
};

export const ModalContextProvider = ({ closeModal, children, onConfirm }: ModalContextProviderProps): JSX.Element => {
    const [formName, setFormName] = useState("DefaultForm");

    const context = useMemo(() => {
        return {
            closeModal,
            setFormName,
            formName,
            onConfirm
        };
    }, [closeModal, setFormName, formName, onConfirm]);

    return <ModalContext.Provider value={context}>{children}</ModalContext.Provider>;
};

interface ModalContextProviderProps {
    closeModal: () => void;
    formName?: string;
    setFormName?: (name: string) => void;
    onConfirm?: () => void;
    children?: React.ReactNode;
}
